import moment from "moment";
import Lottie from "react-lottie";
import { useEffect, useMemo } from "react";
import React, { useState } from "react";
import { Tab } from "@headlessui/react";
import ApiServices from "../api/services";
import Button from "../components/Button";
import { baseUrl } from "../utils/config";
import ReactPaginate from "react-paginate";
import Heading from "../components/Heading";
import Skeleton from "react-loading-skeleton";
import ReactDatePicker from "react-datepicker";
import { useMediaQuery } from "react-responsive";
import RangePicker from "../components/RangePicker";
import { useLoggedContext } from "../context/provider";
import animationData from "../assets/lotties/empty-folder";
import reportAnimationData from "../assets/lotties/report";
import { useSortableData } from "../hooks/useSortableData";
import ShareEmailModal from "../components/ShareEmailModal";
import { Page, Text, View, Document, PDFDownloadLink, pdf, StyleSheet, Image } from "@react-pdf/renderer";
import { ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, ChevronUpIcon } from "@heroicons/react/24/solid";
import Spinner from "../components/Spinner";
import ReportTable from "../components/ReportTable";
import { toUTCUnixTimestamp } from "../helperFunctions/helper";
import { images } from "../assets/styles/Images";
import { HonestWeekPicker } from "../components/WeekDatePicker";
import { useRef } from "react";
import { ArrowPathIcon } from "@heroicons/react/24/outline";
import StatusFilter from "../components/StatusFilter";
import ChildcareReport from "../components/InfoGraphic";
import ChildcareReportPreview from "../components/InfoGraphicReportPreview";
import ChildcarePdfGenerator from "../components/InfoGraphic";
import InfoGraphicReportPreview from "../components/InfoGraphicReportPreview";
import InfoGraphicPdfGenerator from "../components/InfoGraphic";
import { attachCachedIcons } from "../utils/pdfIcons";

// table head
const TABLE_HEAD_HISTORY = ["ID", "Date", "Action"];

const tabs = ["Yearly", "Monthly", "Single Month", "Weekly", "Daily"];

const reportTypeOptions = [
  { label: "Well-being detailed analytical report", value: "analytical" },
  { label: "Statistical Infographic Report", value: "statistical" },
];

const Reports = () => {
  const { btnLoading, setBtnLoading, loading, setLoading, user, feelingsById, reasonsById, feelingsByCode, reasonsByCode } = useLoggedContext();
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const datePickerRef = useRef(null); // Create a ref for the DatePicker

  const [openShareModal, setOpenShareModal] = useState(false);
  const [historyListing, setHistoryListing] = useState([]);
  const [totalPageAllHistory, setTotalPageAllHistory] = useState(0);
  const [currentPageAllHistory, setCurrentPageAllHistory] = useState(1);
  const [saveHistoryLoading, setSaveHistoryLoading] = useState(false);
  const [selectedReportType, setSelectedReportType] = useState(null);

  // Yearly
  const [yearly, setYearly] = useState("");
  const [yearTimestamps, setYeartimestamps] = useState({ startdate: null, enddate: null });
  // Multiple Months
  const [startMonth, setStartMonth] = useState("");
  const [endMonth, setEndMonth] = useState("");
  // Single Month
  const [singleMonth, setSingleMonth] = useState("");
  // Weekly
  const [weekly, setWeekly] = useState("");
  // Daily
  const [dailyDate, setDailyDate] = useState("");
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });

  const [startEndMonthTimestamps, setStartEndMonthTimestamps] = useState({ startdate: null, enddate: null });
  const [singleMonthTimestamps, setSingleMonthTimestamps] = useState({ startdate: null, enddate: null });

  const [reportData, setReportData] = useState({});
  const [reportDataLoading, setReportDataLoading] = useState(false);

  // Table Sorting
  const { items, requestSort, sortConfig } = useSortableData(historyListing);

  // Media Queries
  const isLaptop = useMediaQuery({ minWidth: 1024 });
  const isLaptopMedium = useMediaQuery({ minWidth: 1536 });
  const isLargeScreenLaptop = useMediaQuery({ minWidth: 1700 });
  const itemsPerPage = isLargeScreenLaptop ? 5 : isLaptopMedium ? 6 : isLaptop ? 6 : 10;

  // Pagination
  const handleReportsHisttoryChange = ({ selected }) => {
    setCurrentPageAllHistory(selected + 1);
  };

  const [selectedTabIndex, setSelectedTabIndex] = useState("yearly");

  const handleTabChange = (index) => {
    setSelectedTabIndex(index);
    const clickedTabLabel = tabs[index];

    setSelectedTabIndex(clickedTabLabel);

    setYearly(null);
    setStartMonth(null);
    setEndMonth(null);
    setSingleMonth(null);
    setWeekly(null);
    setDailyDate(null);
  };

  const getReportData = () => {
    console.log("Selected Report Type", yearTimestamps, startEndMonthTimestamps, singleMonthTimestamps, weekly, dailyDate);
    if (yearTimestamps.startdate || startEndMonthTimestamps.startdate || singleMonthTimestamps.startdate || weekly || dailyDate) {
      let payload = {
        group_by:
          selectedTabIndex === "Yearly"
            ? "yearly"
            : selectedTabIndex === "Monthly"
              ? "multiMonth"
              : selectedTabIndex === "Single Month"
                ? "monthly"
                : selectedTabIndex === "Weekly"
                  ? "weekly"
                  : selectedTabIndex === "Daily"
                    ? "daily"
                    : selectedTabIndex,
      };

      switch (selectedTabIndex) {
        case "yearly":
          payload.start_date = yearTimestamps?.startdate;
          payload.end_date = yearTimestamps?.enddate;
          break;
        case "Yearly":
          payload.start_date = yearTimestamps?.startdate;
          payload.end_date = yearTimestamps?.enddate;
          break;
        case "Monthly":
          payload.start_date = startEndMonthTimestamps?.startdate;
          payload.end_date = startEndMonthTimestamps?.enddate;
          break;
        case "Single Month":
          payload.start_date = singleMonthTimestamps?.startdate;
          payload.end_date = singleMonthTimestamps?.enddate;
          break;
        case "Weekly":
          payload.start_date = localToGMTUnixTimestamp(weekly?.firstDay);
          payload.end_date = localToGMTUnixTimestamp(weekly?.lastDay);
          break;
        case "Daily":
          payload.start_date = toUTCUnixTimestampfunction(dailyDate);
          payload.end_date = toUTCUnixTimestampfunctionEndDate(dailyDate);
          break;

        default:
          // Handle other cases if needed
          break;
      }

      setReportDataLoading(true);

      console.log("Payload", payload);

      ApiServices.report
        .getReport(payload)
        .then((res) => {
          const { data, message } = res;

          if (data.code === 200) {
            setReportDataLoading(false);
            // Add nursery name to the report data
            setReportData({
              ...data?.data,
              organization_name: (user?.user?.nursery?.[0]?.name || "Organization").toUpperCase()
            });
          }
        })
        .catch((err) => { });
    }
  };

  // Stamp the report's feelings/reasons with the base64 icons already resolved at
  // login (cached in lookups). Pure/synchronous — no network at report load or
  // at Download click.
  const pdfReportData = useMemo(
    () => attachCachedIcons(reportData, feelingsById, reasonsById, feelingsByCode, reasonsByCode),
    [reportData, feelingsById, reasonsById, feelingsByCode, reasonsByCode],
  );

  useEffect(() => {
    if (startMonth && endMonth) {
      const startdate = getMonthStartDate(startMonth);
      const enddate = getMonthEndDate(endMonth);
      setStartEndMonthTimestamps({ startdate, enddate });
    }
  }, [startMonth, endMonth]);

  useEffect(() => {
    if (singleMonth) {
      const { startdate, enddate } = getMonthStartAndEndDate(singleMonth);
      setSingleMonthTimestamps({ startdate, enddate });
    }
  }, [singleMonth]);

  function localToGMTUnixTimestamp(localDateString) {
    const localDateTime = new Date(localDateString);
    const gmtDateTime = new Date(localDateTime.getTime() - localDateTime.getTimezoneOffset() * 60000);
    gmtDateTime.setUTCHours(0);
    gmtDateTime.setUTCMinutes(0);
    gmtDateTime.setUTCSeconds(0);
    gmtDateTime.setUTCMilliseconds(0);
    const unixTimestamp = Math.floor(gmtDateTime.getTime() / 1000);
    return unixTimestamp;
  }

  const getHistoryData = () => {
    let payload = {
      page: currentPageAllHistory,
      records_no: 5,
      start_date: dateRange.startDate,
      end_date: dateRange.endDate,
    };

    setLoading(true);

    ApiServices.report
      .getHistoryList(payload)
      .then((res) => {
        const { data, message } = res;

        if (data?.code === 200) {
          setLoading(false);
          setHistoryListing(data?.data?.data);
          setCurrentPageAllHistory(data?.data?.current_page);
          setTotalPageAllHistory(Math.ceil(data?.data?.total / data?.data?.per_page));
        }
      })
      .catch((err) => { });
  };

  useEffect(() => {
    getHistoryData();
  }, [currentPageAllHistory, dateRange]);

  useEffect(() => {
    if (yearly) {
      const year = new Date(yearly).getFullYear();
      const startdate = new Date(Date.UTC(year, 0, 1, 0, 0, 0, 0));
      const enddate = new Date(Date.UTC(year, 11, 31, 23, 59, 59, 999));

      // Handle timezone offset like in your other functions
      const timezoneOffsetInMinutes = startdate.getTimezoneOffset();
      startdate.setMinutes(startdate.getMinutes() - timezoneOffsetInMinutes);
      startdate.setUTCHours(0, 0, 0, 0);

      enddate.setMinutes(enddate.getMinutes() - timezoneOffsetInMinutes);
      enddate.setUTCHours(23, 59, 59, 999);

      // Convert to Unix timestamps
      const startTimestamp = Math.floor(startdate.getTime() / 1000);
      const endTimestamp = Math.floor(enddate.getTime() / 1000);

      setYeartimestamps({
        startdate: startTimestamp,
        enddate: endTimestamp
      });
    }
  }, [yearly]);

  const handleView = (item) => {
    window.open(`${baseUrl}images/report_pdf/` + item?.file, "_blank");
  };

  const handleDownload = (item) => {
    window.open(`${baseUrl}images/report_pdf/` + item?.file);
  };

  function stripHtml(html) {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  }



  // generating PDF of Well-being analytical report
  // generating PDF of Well-being analytical report (dynamic, code-based)
  // `data` is the icon-embedded report payload (icons stamped from the cached,
  // login-resolved base64) so the PDF renders from in-memory data URIs and never
  // fetches at render time.
  const EnhancedDocument = ({ data }) => {
    const dyn = data?.dynamic;
    const pdfFeelings = dyn?.summary?.feelings || [];
    const pdfFeelingSeries = dyn?.feelings_series || [];
    const pdfNegReasons = dyn?.summary?.negative_reasons || [];
    const pdfPosReasons = dyn?.summary?.positive_reasons || [];
    const pdfReasonSeries = dyn?.reasons_series || [];

    const periodHeaderLabel =
      data?.type === "daily" ? "Hour" : data?.type === "monthly" ? "Date" : data?.type === "weekly" ? "Weekly" : "Month";
    const periodCell = (row) => {
      if (data?.type === "daily") return moment(row.hour || row.date).format("MMM D YYYY h:mm A");
      if (data?.type === "monthly" || data?.type === "weekly") return moment(row.date).format("MMM D YYYY");
      return row.month || row.date;
    };

    // Heat highlight for arbitrary-length value lists.
    const heatStyle = (value, allValues) => {
      const vals = allValues.filter((v) => typeof v === "number" && !isNaN(v));
      const sorted = [...vals].sort((a, b) => b - a);
      if (!value) return [styles.tableCol];
      if (value === sorted[0]) return [styles.tableCol, { backgroundColor: "#88FA4E" }];
      if (value === sorted[1] && sorted.length > 1) return [styles.tableCol, { backgroundColor: "#FED477" }];
      if (value === sorted[sorted.length - 1] && sorted.length > 2) return [styles.tableCol, { backgroundColor: "#FF968D" }];
      return [styles.tableCol];
    };

    const feelingColWidth = `${66 / Math.max(pdfFeelings.length, 1)}%`;
    const reasonColWidth = `${90 / Math.max(pdfNegReasons.length, 1)}%`;
    const posReasonColWidth = `${90 / Math.max(pdfPosReasons.length, 1)}%`;
    const seriesCounts = pdfFeelingSeries.map((r) => r.Count || 0);
    const maxC = seriesCounts.length ? Math.max(...seriesCounts) : 0;
    const minC = seriesCounts.length ? Math.min(...seriesCounts) : 0;
    const feelingTotals = pdfFeelings.map((f) => f.count || 0);
    const reasonTotals = pdfNegReasons.map((r) => r.count || 0);
    const posReasonTotals = pdfPosReasons.map((r) => r.count || 0);

    return (
      <Document>
        {/* Entries Table */}
        <Page size="A3" orientation="portrait" style={styles.page}>
          <View style={styles.header}>
            <Text style={styles.headerText}>{data?.organization_name || "Organization"}</Text>
            <Text style={styles.subtitleText}>Well-being Analytical Report</Text>
            <Text style={styles.subtitleText}>
              {selectedTabIndex === "Yearly"
                ? `Year: ${moment(yearly).format("YYYY")}`
                : selectedTabIndex === "Monthly"
                  ? `From: ${moment(startMonth).format("MMM YYYY")} To: ${moment(endMonth).format("MMM YYYY")}`
                  : selectedTabIndex === "Single Month"
                    ? `Month: ${moment(singleMonth).format("MMMM YYYY")}`
                    : selectedTabIndex === "Weekly"
                      ? `Week: ${moment(weekly?.firstDay).format("MMM D YYYY")} - ${moment(weekly?.lastDay).format("MMM D YYYY")}`
                      : selectedTabIndex === "Daily"
                        ? `Date: ${moment(dailyDate).format("MMM D YYYY")}`
                        : ""}
            </Text>
          </View>

          <View style={[styles.sectionContainer, { alignItems: 'center', marginTop: 30 }]}>
            <View style={[styles.table, { width: '95%' }]}>
              <View style={styles.tableRow}>
                <View style={[styles.colSpan7, styles.tableColHeader]}>
                  <Text style={styles.sectionTitleBold}>Entries</Text>
                </View>
              </View>

              <View style={styles.tableRow}>
                <View style={[styles.tableColHeader, { width: '22%' }]}>
                  <Text style={styles.tableCellHeader}>{periodHeaderLabel}</Text>
                </View>
                {pdfFeelings.map((feeling) => (
                  <View key={feeling.code} style={[styles.tableColHeader, { width: feelingColWidth }]}>
                    <View style={styles.flexContainer}>
                      {feeling.icon_data ? <Image src={feeling.icon_data} style={styles.image} /> : null}
                      <Text style={styles.tableCellHeader}>{feeling.name}</Text>
                    </View>
                  </View>
                ))}
                <View style={[styles.tableColHeader, { width: '12%' }]}>
                  <Text style={styles.tableCellHeader}>Entries</Text>
                </View>
              </View>

              {pdfFeelingSeries.map((row, index) => (
                <View key={index} style={index % 2 === 0 ? styles.tableRowEven : styles.tableRow}>
                  <View style={[styles.tableColFirst, { width: '22%' }]}>
                    <Text style={styles.tableCell}>{periodCell(row)}</Text>
                  </View>
                  {pdfFeelings.map((feeling) => (
                    <View key={feeling.code} style={[styles.tableCol, { width: feelingColWidth }]}>
                      <Text style={styles.tableCellRight}>{row?.counts?.[feeling.code] ?? 0}</Text>
                    </View>
                  ))}
                  <View style={[
                    styles.tableCol,
                    { width: '12%' },
                    row.Count === maxC ? { backgroundColor: "#88FA4E" } : row.Count === minC ? { backgroundColor: "#FF968D" } : {}
                  ]}>
                    <Text style={styles.tableCellRight}>{row.Count}</Text>
                  </View>
                </View>
              ))}

              {/* Total Row */}
              <View style={[styles.tableRow, { backgroundColor: "white" }]}>
                <View style={[styles.tableColFirst, { width: '22%' }]}>
                  <Text style={[styles.tableCell, styles.bold]}>Total</Text>
                </View>
                {pdfFeelings.map((feeling) => (
                  <View key={feeling.code} style={[...heatStyle(feeling.count || 0, feelingTotals), { width: feelingColWidth }]}>
                    <Text style={[styles.tableCellRight, styles.bold]}>{feeling.count || 0}</Text>
                  </View>
                ))}
                <View style={[styles.tableCol, { width: '12%' }]}>
                  <Text style={[styles.tableCellRight, styles.bold]}></Text>
                </View>
              </View>

              {/* Percentages Row */}
              <View style={[styles.tableRow, { backgroundColor: "white" }]}>
                <View style={[styles.tableColFirst, { width: '22%' }]}></View>
                {pdfFeelings.map((feeling) => (
                  <View key={feeling.code} style={[styles.tableCol, { width: feelingColWidth }]}>
                    <Text style={[styles.tableCellRight, styles.bold]}>{feeling.percentage ?? 0}%</Text>
                  </View>
                ))}
                <View style={[styles.tableCol, { width: '12%' }]}></View>
              </View>
            </View>
          </View>
        </Page>

        {/* Reasons Table */}
        <Page size="A1" orientation="landscape" style={styles.page}>
          <View style={styles.sectionContainer}>
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <View style={[styles.colSpan7, styles.tableColHeader]}>
                  <Text style={styles.sectionTitleBold}>Reasons ( meh, low, struggling )</Text>
                </View>
              </View>

              <View style={styles.tableRow}>
                <View style={[styles.tableColFirst, { width: '10%' }]}>
                  <Text style={styles.tableCellHeader}>{periodHeaderLabel}</Text>
                </View>
                {pdfNegReasons.map((reason) => (
                  <View key={reason.code} style={[styles.tableCol, { width: reasonColWidth }]}>
                    <View style={styles.flexContainerVertical}>
                      {reason.icon_data ? <Image src={reason.icon_data} style={styles.reasonIcon} /> : null}
                      <Text style={styles.tableCellHeaderSmall}>{reason.name}</Text>
                    </View>
                  </View>
                ))}
              </View>

              {pdfReasonSeries.map((row, index) => (
                <View key={index} style={index % 2 === 0 ? styles.tableRowEven : styles.tableRow}>
                  <View style={[styles.tableColFirst, { width: '10%' }]}>
                    <Text style={styles.tableCell}>{periodCell(row)}</Text>
                  </View>
                  {pdfNegReasons.map((reason) => (
                    <View key={reason.code} style={[styles.tableCol, { width: reasonColWidth }]}>
                      <Text style={styles.tableCellRight}>{row?.counts?.[reason.code] ?? 0}</Text>
                    </View>
                  ))}
                </View>
              ))}

              {/* Totals Row */}
              <View style={[styles.tableRow, { backgroundColor: "white" }]}>
                <View style={[styles.tableColFirst, { width: '10%' }]}>
                  <Text style={[styles.tableCell, styles.bold]}>Total</Text>
                </View>
                {pdfNegReasons.map((reason) => (
                  <View key={reason.code} style={[...heatStyle(reason.count || 0, reasonTotals), { width: reasonColWidth }]}>
                    <Text style={[styles.tableCellRight, styles.bold]}>{reason.count || 0}</Text>
                  </View>
                ))}
              </View>

              {/* Percentages Row */}
              <View style={[styles.tableRow, { backgroundColor: "white" }]}>
                <View style={[styles.tableColFirst, { width: '10%' }]}></View>
                {pdfNegReasons.map((reason) => (
                  <View key={reason.code} style={[styles.tableCol, { width: reasonColWidth }]}>
                    <Text style={[styles.tableCellRight, styles.bold]}>{reason.percentage ?? 0}%</Text>
                  </View>
                ))}
              </View>
            </View>
          </View>
        </Page>

        {/* Positive Reasons Table */}
        {pdfPosReasons.length > 0 && (
          <Page size="A1" orientation="landscape" style={styles.page}>
            <View style={styles.sectionContainer}>
              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <View style={[styles.colSpan7, styles.tableColHeader]}>
                    <Text style={styles.sectionTitleBold}>Positive Reasons ( okay, good, great )</Text>
                  </View>
                </View>

                <View style={styles.tableRow}>
                  <View style={[styles.tableColFirst, { width: '10%' }]}>
                    <Text style={styles.tableCellHeader}>{periodHeaderLabel}</Text>
                  </View>
                  {pdfPosReasons.map((reason) => (
                    <View key={reason.code} style={[styles.tableCol, { width: posReasonColWidth }]}>
                      <View style={styles.flexContainerVertical}>
                        {reason.icon_data ? <Image src={reason.icon_data} style={styles.reasonIcon} /> : null}
                        <Text style={styles.tableCellHeaderSmall}>{reason.name}</Text>
                      </View>
                    </View>
                  ))}
                </View>

                {pdfReasonSeries.map((row, index) => (
                  <View key={index} style={index % 2 === 0 ? styles.tableRowEven : styles.tableRow}>
                    <View style={[styles.tableColFirst, { width: '10%' }]}>
                      <Text style={styles.tableCell}>{periodCell(row)}</Text>
                    </View>
                    {pdfPosReasons.map((reason) => (
                      <View key={reason.code} style={[styles.tableCol, { width: posReasonColWidth }]}>
                        <Text style={styles.tableCellRight}>{row?.counts?.[reason.code] ?? 0}</Text>
                      </View>
                    ))}
                  </View>
                ))}

                {/* Totals Row */}
                <View style={[styles.tableRow, { backgroundColor: "white" }]}>
                  <View style={[styles.tableColFirst, { width: '10%' }]}>
                    <Text style={[styles.tableCell, styles.bold]}>Total</Text>
                  </View>
                  {pdfPosReasons.map((reason) => (
                    <View key={reason.code} style={[...heatStyle(reason.count || 0, posReasonTotals), { width: posReasonColWidth }]}>
                      <Text style={[styles.tableCellRight, styles.bold]}>{reason.count || 0}</Text>
                    </View>
                  ))}
                </View>

                {/* Percentages Row */}
                <View style={[styles.tableRow, { backgroundColor: "white" }]}>
                  <View style={[styles.tableColFirst, { width: '10%' }]}></View>
                  {pdfPosReasons.map((reason) => (
                    <View key={reason.code} style={[styles.tableCol, { width: posReasonColWidth }]}>
                      <Text style={[styles.tableCellRight, styles.bold]}>{reason.percentage ?? 0}%</Text>
                    </View>
                  ))}
                </View>
              </View>
            </View>
          </Page>
        )}

        {/* Evaluation Table */}
        <Page size="A3" orientation="landscape" style={styles.page}>
          {data?.Evaluation?.length > 0 && (
            <View style={[styles.sectionContainer, styles.evaluationContainer]}>
              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <View style={[styles.tableColHeader, { width: '20%', borderBottomWidth: 1 }]}>
                    <Text style={styles.tableCellHeader}>Date</Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '40%', borderBottomWidth: 1 }]}>
                    <Text style={styles.tableCellHeader}>Evaluation of data</Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '40%', borderBottomWidth: 1, borderRightWidth: 1 }]}>
                    <Text style={styles.tableCellHeader}>Actions</Text>
                  </View>
                </View>

                {data?.Evaluation?.map((row, index) => (
                  <View key={index} style={index % 2 === 0 ? styles.tableRowEven : styles.tableRow}>
                    <View style={[styles.tableColFirst, { width: '20%', alignSelf: 'flex-start', borderBottomWidth: 1 }]}>
                      <Text style={styles.tableCell}>
                        {moment.unix(row?.created_at_unix).format("D MMM YYYY")}
                      </Text>
                    </View>
                    <View style={[styles.tableCol2, { width: '40%', borderBottomWidth: 1 }]}>
                      <Text style={styles.tableCell}>{row?.evaluation?.replace(/<[^>]*>?/gm, '')}</Text>
                    </View>
                    <View style={[styles.tableCol2, { width: '40%', borderBottomWidth: 1, borderRightWidth: 1 }]}>
                      <Text style={styles.tableCell}>{row?.action?.replace(/<[^>]*>?/gm, '')}</Text>
                    </View>
                  </View>
                ))}
              </View>
            </View>
          )}
        </Page>
      </Document>
    );
  };

  const generatePDFBlob = async () => {
    try {
      if (!reportData || Object.keys(reportData).length === 0) {
        console.error("No report data available for PDF generation");
        return null;
      }

      // Icons were resolved to base64 at login and cached in lookups; this copy
      // is stamped synchronously, so there are no network requests here.
      const safeData = pdfReportData;

      if (selectedReportType?.value === "statistical") {
        return await pdf(<InfoGraphicPdfGenerator data={safeData} />).toBlob();
      } else {
        return await pdf(<EnhancedDocument data={safeData} />).toBlob();
      }
    } catch (error) {
      console.error("Error generating PDF:", error);
      return null;
    }
  };

  const uploadFile = async (pdfBlob) => {
    const formData = new FormData();
    formData.append("file", pdfBlob, "report.pdf");
    formData.append("type", selectedReportType?.label);

    try {
      const res = await ApiServices.report.uploadReport(formData);

      if (res.code === 200) {
        return `${baseUrl}images/report_pdf/` + res.data;
      }
    } catch (err) {
      throw err;
    }
  };

  const sendEmailWithUrl = (url) => {
    const emailBody = `Report URL: ${url}`;
    window.location.href = `mailto:?body=${encodeURIComponent(emailBody)}`;
  };

  const handleGenerateAndUploadPDF = async () => {
    try {
      setBtnLoading(true);
      const pdfBlob = await generatePDFBlob();

      const fileUrl = await uploadFile(pdfBlob);

      if (fileUrl) {
        sendEmailWithUrl(fileUrl);
      }
    } catch (error) {
      console.error("Error generating and uploading PDF:", error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleGenerateAndUploadPDFInSaveHistory = async () => {
    try {
      setSaveHistoryLoading(true);
      const pdfBlob = await generatePDFBlob();

      await uploadFile(pdfBlob);
      getHistoryData();
    } catch (error) {
      console.error("Error saving to history:", error);
    } finally {
      setSaveHistoryLoading(false);
    }
  };

  const handleStartMonthChange = (date) => {
    setStartMonth(date);
    if (endMonth && date && date <= endMonth) {
      setEndMonth(null);
    }
  };

  const handleEndMonthChange = (date) => {
    if (startMonth && date && date < startMonth) {
      return;
    }
    setEndMonth(date);
  };

  const getMonthStartDate = (month) => {
    const startDate = new Date(month);
    const startDateGMT = new Date(Date.UTC(startDate.getFullYear(), startDate.getMonth(), 1));
    return Math.floor(startDateGMT.getTime() / 1000);
  };

  const getMonthEndDate = (startDateString) => {
    const startDate = new Date(startDateString);
    const endDate = new Date(startDate);
    endDate.setUTCMonth(endDate.getUTCMonth() + 2);
    endDate.setUTCDate(0);
    endDate.setUTCHours(0, 0, 0, 0);
    return Math.floor(endDate.getTime() / 1000);
  };

  const toggleDatePicker = () => {
    setIsDatePickerOpen(!isDatePickerOpen);
  };


  const getMonthStartAndEndDate = (month) => {
    const date = new Date(month);
    const startdate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0));
    const enddate = new Date(Date.UTC(date.getFullYear(), date.getMonth() + 1, 0, 0, 0, 0, 0));

    const timezoneOffsetInMinutes = startdate.getTimezoneOffset();
    startdate.setMinutes(startdate.getMinutes() - timezoneOffsetInMinutes);
    startdate.setUTCHours(0, 0, 0, 0);

    enddate.setMinutes(enddate.getMinutes() - timezoneOffsetInMinutes);
    enddate.setUTCHours(0, 0, 0, 0);

    return {
      startdate: startdate.getTime() / 1000,
      enddate: enddate.getTime() / 1000,
    };
  };

  const toUTCUnixTimestampfunction = (dailyDate) => {
    const date = new Date(dailyDate);
    const localOffset = date.getTimezoneOffset();
    date.setMinutes(date.getMinutes() - localOffset);

    date.setUTCHours(0, 0, 0);
    return Math.floor(date.getTime() / 1000);
  };

  const toUTCUnixTimestampfunctionEndDate = (dailyDate) => {
    const date = new Date(dailyDate);
    const localOffset = date.getTimezoneOffset();
    date.setMinutes(date.getMinutes() - localOffset);

    date.setUTCHours(23, 59, 59, 0);
    return Math.floor(date.getTime() / 1000);
  };

  const emptyFolderAnimation = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const reportAnimation = {
    loop: true,
    autoplay: true,
    animationData: reportAnimationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <>
      <div className="grid min-h-[83vh] grid-cols-12 gap-4">
        <div className="col-span-12 flex flex-col gap-y-7  xl:col-span-5 xl:gap-y-5 ">
          {(user?.user?.permissions?.includes("report-generate") || user?.user?.role === "setting_user") && (
            <div className="card flex-grow">
              <div className="pt-4">
                <Heading
                  heading="Generate Report"
                  subheading="Long established fact that a reader will be distracted by the readable content of a page when looking at its layout."
                />
              </div>
              <div className="space-y-2 ">
                <div className="w-full">
                  <Tab.Group>
                    <Tab.List className="mt-8  flex">
                      {tabs.map((tabLabel, index) => (
                        <Tab
                          key={index}
                          onClick={() => handleTabChange(index)}
                          className={({
                            selected,
                          }) => `flex w-full justify-center border-b-2 py-2.5 text-left text-sm font-medium leading-5 focus:outline-none xl:text-xs 2xl:px-2 2xl:text-sm
                           ${selected ? "border-secondary font-semibold text-secondary" : "text-primary-color-300 hover:text-secondary"}`}
                        >
                          {tabLabel}
                        </Tab>
                      ))}
                    </Tab.List>
                    <Tab.Panels className="mt-6">
                      <Tab.Panel className="grid grid-cols-2 gap-x-3">
                        <div className="relative">
                          <p className="mb-4 text-sm font-medium text-primary-color-100">Select Year</p>
                          <ReactDatePicker
                            ref={datePickerRef}
                            placeholderText="Select"
                            showYearPicker
                            dateFormat="yyyy"
                            selected={yearly}
                            onChange={(date) => {
                              setYearly(date);
                              setIsDatePickerOpen(false);
                            }}
                            onClickOutside={() => setIsDatePickerOpen(false)}
                            open={isDatePickerOpen}
                            yearItemNumber={6}
                            onFocus={() => setIsDatePickerOpen(true)}
                          />
                          <div className="absolute right-5 bottom-3" onClick={toggleDatePicker}>
                            <ChevronDownIcon className="inline-block h-5 w-5" />
                          </div>
                        </div>

                        <div className="space-y-4">
                          <h3 className="font-poppins text-sm font-medium text-primary-color-200">Report Type</h3>
                          <StatusFilter
                            drawerFilter
                            options={reportTypeOptions}
                            selected={selectedReportType}
                            setSelected={setSelectedReportType}
                            maxWidth="w-full h-11"
                            report
                          />
                        </div>
                      </Tab.Panel>

                      <Tab.Panel className="grid grid-cols-3  gap-x-3">
                        <div className="relative">
                          <p className="mb-4 text-sm font-medium text-primary-color-100">Start Month</p>
                          <ReactDatePicker
                            ref={datePickerRef}
                            onClickOutside={() => setIsDatePickerOpen(false)}
                            open={isDatePickerOpen}
                            onFocus={() => setIsDatePickerOpen(true)}
                            placeholderText="Select"
                            showMonthYearPicker
                            dateFormat="MMM/yyyy"
                            selected={startMonth}
                            onChange={(date) => {
                              handleStartMonthChange(date);
                              setIsDatePickerOpen(false);
                            }}
                          />
                          <div className="absolute right-5 bottom-3" onClick={toggleDatePicker}>
                            <ChevronDownIcon className="inline-block h-5 w-5" />
                          </div>
                        </div>
                        <div className="relative">
                          <p className="mb-4 text-sm font-medium text-primary-color-100">End Month</p>
                          <ReactDatePicker
                            filterDate={(date) => date > startMonth}
                            minDate={startMonth}
                            placeholderText="Select"
                            showMonthYearPicker
                            dateFormat="MMM/yyyy"
                            selected={endMonth}
                            onChange={handleEndMonthChange}
                          />
                          <div className="absolute right-5 bottom-3">
                            <ChevronDownIcon className="inline-block h-5 w-5" />
                          </div>
                        </div>
                        <div className="space-y-4">
                          <h3 className="font-poppins text-sm font-medium text-primary-color-200">Report Type</h3>
                          <StatusFilter
                            drawerFilter
                            options={reportTypeOptions}
                            selected={selectedReportType}
                            setSelected={setSelectedReportType}
                            maxWidth="w-full h-11"
                            report
                          />
                        </div>
                      </Tab.Panel>
                      <Tab.Panel className="grid grid-cols-2 gap-x-3">
                        <div className="relative">
                          <p className="mb-4 text-sm font-medium text-primary-color-100">Select Month</p>
                          <ReactDatePicker
                            ref={datePickerRef}
                            onClickOutside={() => setIsDatePickerOpen(false)}
                            open={isDatePickerOpen}
                            onFocus={() => setIsDatePickerOpen(true)}
                            placeholderText="Select"
                            showMonthYearPicker
                            dateFormat="MMM/yyyy"
                            selected={singleMonth}
                            onChange={(date) => {
                              setSingleMonth(date);
                              setIsDatePickerOpen(false);
                            }}
                          />

                          <div className="absolute right-5 bottom-3" onClick={toggleDatePicker}>
                            <ChevronDownIcon className="inline-block h-5 w-5" />
                          </div>
                        </div>
                        <div className="space-y-4">
                          <h3 className="font-poppins text-sm font-medium text-primary-color-200">Report Type</h3>
                          <StatusFilter
                            drawerFilter
                            options={reportTypeOptions}
                            selected={selectedReportType}
                            setSelected={setSelectedReportType}
                            maxWidth="w-full h-11"
                            report
                          />
                        </div>
                      </Tab.Panel>
                      <Tab.Panel className="grid grid-cols-2 gap-x-3">
                        <div className="relative">
                          <p className="mb-4 text-sm font-medium text-primary-color-100">Select Week</p>
                          <HonestWeekPicker onChange={(week) => setWeekly(week)} />
                        </div>
                        <div className="space-y-4">
                          <h3 className="font-poppins text-sm font-medium text-primary-color-200">Report Type</h3>
                          <StatusFilter
                            drawerFilter
                            options={reportTypeOptions}
                            selected={selectedReportType}
                            setSelected={setSelectedReportType}
                            maxWidth="w-full h-11"
                            report
                          />
                        </div>
                      </Tab.Panel>
                      <Tab.Panel className="grid grid-cols-2 gap-x-3">
                        <div className="relative">
                          <p className="mb-4 text-sm font-medium text-primary-color-100">Select Date</p>
                          <ReactDatePicker
                            ref={datePickerRef}
                            onClickOutside={() => setIsDatePickerOpen(false)}
                            open={isDatePickerOpen}
                            onFocus={() => setIsDatePickerOpen(true)}
                            selected={dailyDate}
                            dateFormat="dd/MMM/yyyy"
                            onChange={(date) => {
                              setDailyDate(date);
                              setIsDatePickerOpen(false);
                            }}
                            placeholderText="Select"
                          />
                          <div className="absolute right-5 bottom-3" onClick={toggleDatePicker}>
                            <ChevronDownIcon className="inline-block h-5 w-5" />
                          </div>
                        </div>
                        <div className="space-y-4">
                          <h3 className="font-poppins text-sm font-medium text-primary-color-200">Report Type</h3>
                          <StatusFilter
                            drawerFilter
                            options={reportTypeOptions}
                            selected={selectedReportType}
                            setSelected={setSelectedReportType}
                            maxWidth="w-full h-11"
                            report
                          />
                        </div>
                      </Tab.Panel>
                    </Tab.Panels>
                  </Tab.Group>
                </div>

                <div className="flex cursor-pointer justify-end pt-5">
                  <span
                    className={`text-xs font-medium text-secondary ${yearly || dailyDate || weekly || singleMonth || startMonth || endMonth ? "opacity-100" : "cursor-not-allowed opacity-50"
                      } underline 3xl:text-lg`}
                    onClick={() => { getReportData() }}
                  >
                    Generate
                  </span>
                </div>
              </div>
            </div>
          )}
          {(user?.user?.permissions?.includes("report-view-history") || user?.user?.role === "setting_user") && (
            <div className="card flex-grow-[2]">
              <div className="flex items-center justify-between pt-4">
                <div className="flex items-center gap-x-2">
                  <Heading
                    heading="History"
                    icon
                    handleRefresh={() => {
                      getHistoryData();
                    }}
                  />
                </div>
                <RangePicker setRangePicker={setDateRange} width="3xl:w-80 2xl:w-60 xl:w-76" />
              </div>
              <div className="pt-4">
                <div className="-mx-6 mb-8 overflow-x-auto">
                  <table className="w-full text-left">
                    <thead>
                      <tr>
                        {TABLE_HEAD_HISTORY?.map((head) => (
                          <th
                            key={head}
                            className="border-b border-gray-100 bg-white p-4 first:pl-6"
                            onClick={() => {
                              let sortKey;
                              if (head === "ID") {
                                sortKey = "transaction_id";
                              } else if (head === "Report Type") {
                                sortKey = "report_type";
                              } else if (head === "Date") {
                                sortKey = "start_date";
                              } else {
                                sortKey = head.toLowerCase();
                              }
                              requestSort(sortKey);
                            }}
                          >
                            <p className="cursor-pointer whitespace-nowrap font-inter text-xs font-semibold leading-5 3xl:text-sm">
                              {head}
                              {sortConfig.key ===
                                (head === "ID"
                                  ? "transaction_id"
                                  : head === "Report Type"
                                    ? "report_type"
                                    : head === "Date"
                                      ? "start_date"
                                      : head.toLowerCase()) && sortConfig.direction === "asc" ? (
                                <>{head === "Action" ? "" : <ChevronUpIcon className="inline-block h-4 w-3.5" />}</>
                              ) : (
                                <>{head === "Action" ? "" : <ChevronDownIcon className="inline-block h-4 w-3.5" />}</>
                              )}
                            </p>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="6">
                            <Skeleton count={itemsPerPage} height={55} />
                          </td>
                        </tr>
                      ) : items.length > 0 ? (
                        items.map((item, index) => (
                          <tr key={item?.id} className="transition-all duration-300 even:bg-gray-50 hover:bg-secondary/10">
                            <td className="py-5 pl-4 3xl:px-4">
                              <p className="text-xs font-normal text-primary-color-200 3xl:text-sm">{item?.id}</p>
                            </td>
                            <td className="py-5 pl-4 3xl:px-4">
                              <p className="text-xs font-normal text-primary-color-200 3xl:text-sm">
                                {moment.unix(item?.created_at_unix).format("D MMM YYYY")}
                              </p>
                            </td>
                            <td>
                              <div className="flex items-center gap-x-3">
                                <span
                                  className="cursor-pointer text-xs font-normal text-accent underline 3xl:text-sm"
                                  onClick={() => handleView(item)}
                                >
                                  View
                                </span>
                                <span
                                  className="cursor-pointer text-xs font-normal text-secondary underline 3xl:text-sm"
                                  onClick={() => handleDownload(item)}
                                >
                                  Download
                                </span>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr className=" h-[300px]">
                          <td colSpan="6">
                            <Lottie options={emptyFolderAnimation} width={200} height={200} />
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="absolute bottom-4">
                  <ReactPaginate
                    breakLabel="..."
                    pageRangeDisplayed={5}
                    forcePage={currentPageAllHistory - 1}
                    marginPagesDisplayed={2}
                    activeClassName="active"
                    nextClassName="item next"
                    renderOnZeroPageCount={null}
                    breakClassName="item break-me "
                    containerClassName="pagination"
                    onPageChange={handleReportsHisttoryChange}
                    previousClassName="item previous"
                    pageClassName="item pagination-page "
                    pageCount={totalPageAllHistory}
                    nextLabel={<ChevronRightIcon className="h-5 w-5" />}
                    previousLabel={<ChevronLeftIcon className="h-5 w-5" />}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
        {(user?.user?.permissions?.includes("report-view-history") || user?.user?.role === "setting_user") && (
          <div className="card col-span-12 xl:col-span-7">
            {reportDataLoading ? (
              <>
                <div className="flex items-center justify-between">
                  <Heading heading="Preview" />
                  <div className="flex items-center space-x-3">
                    <Skeleton count={1} height={30} width={100} />
                    <Skeleton count={1} height={30} width={100} />
                    <Skeleton count={1} height={30} width={100} />
                  </div>
                </div>
                <div className="mt-4">
                  <Skeleton count={1} height={700} />
                </div>
              </>
            ) : Object.keys(reportData).length > 0 ? (
              <>
                <div className="flex items-center justify-between pb-4">
                  <Heading heading="Preview" />
                  <div className="flex items-center space-x-3">
                    <Button
                      title={saveHistoryLoading ? <Spinner /> : "Save in History"}
                      btnSmall
                      buttonColor="bg-[#8EE1C8] text-white"
                      className="w-100"
                      onClick={() => handleGenerateAndUploadPDFInSaveHistory()}
                    />

                    {(user?.user?.permissions?.includes("report-download-share") || user?.user?.role === "setting_user") && (
                      <>
                        <Button
                          title={btnLoading ? <Spinner /> : "Share via email"}
                          btnSmall
                          buttonColor="bg-[#FF9D86] text-white"
                          className="w-100"
                          onClick={() => handleGenerateAndUploadPDF()}
                        />

                        <Button
                          title="Download"
                          btnSmall
                          className="w-100"
                          onClick={async () => {
                            try {
                              // Show loading indicator if needed
                              // setIsDownloading(true);

                              const blob = await generatePDFBlob();
                              if (!blob) {
                                console.error("Failed to generate PDF");
                                return;
                              }

                              // Create download link
                              const url = URL.createObjectURL(blob);
                              const link = document.createElement('a');
                              link.href = url;
                              link.download = `${reportData?.organization_name || 'Report'}-${new Date().toLocaleDateString().replace(/\//g, '-')}.pdf`;

                              // Trigger download
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);

                              // Clean up
                              URL.revokeObjectURL(url);
                            } catch (error) {
                              console.error("Error downloading PDF:", error);
                            } finally {
                              // Hide loading indicator if needed
                              // setIsDownloading(false);
                            }
                          }}
                        />
                      </>
                    )}
                  </div>
                </div>

                <div className="-mr-5 h-[83vh] overflow-y-auto">
                  <div className="pr-5">
                    {selectedReportType?.value === "statistical" ? (
                      <InfoGraphicReportPreview data={pdfReportData} />
                    ) : (
                      <ReportTable reportData={pdfReportData} />
                    )}
                  </div>
                </div>
              </>
            ) : (
              <div className="flex h-full items-center justify-center">
                <div className="flex flex-col">
                  <Lottie options={reportAnimation} width={200} height={200} />
                  <p className="text-center text-lg font-medium text-gray-400">Please Select a Date Range</p>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      <ShareEmailModal isOpen={openShareModal} setIsOpen={setOpenShareModal} />
    </>
  );
};

export default Reports;

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    padding: 30,
  },
  header: {
    marginBottom: 20,
    borderBottom: "1px solid #CCCCCC",
    paddingBottom: 10,
  },
  headerText: {
    fontSize: 20, // Increased from 18 for better visual hierarchy
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 10,
  },
  subtitleText: {
    fontSize: 14,
    fontWeight: "medium",
    textAlign: "center",
    color: "#667080", // Using the secondary text color
    marginTop: 5,
  },
  sectionContainer: {
    marginBottom: 20,
    alignSelf: "flex-start", // This also helps prevent stretching
    width: "100%",
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: "bold",
  },
  sectionTitleBold: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#000000",
    padding: 5,
  },
  table: {
    display: "table",
    width: "100%", // Change from "auto" to "100%" for consistent width
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginBottom: 15,
    alignSelf: "flex-start", // This prevents stretching
  },
  padding: {
    paddingBottom: 30,
  },
  tableRow: {
    flexDirection: "row",
    backgroundColor: "#F6F7F8",
    minHeight: 30,
  },
  tableRowEven: {
    flexDirection: "row",
    backgroundColor: "#FFFFFF",
    minHeight: 30,
  },
  tableColHeader: {
    width: "6.5%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#F6F7F8",
    padding: 2,
  },
  reasonTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#F6F7F8",
    padding: 2,
  },
  reasonIconCol: {
    width: "5.8%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#F6F7F8",
    padding: 2,
  },
  tableColHeader2: {
    width: "42.84%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#F6F7F8",
    padding: 5,
  },
  tableCol: {
    width: "6.5%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 2,
  },
  tableColFirst: {
    width: "10%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 3,
  },
  tableColHidden: {
    width: "17%",
    borderWidth: 0,
  },
  tableCol2: {
    width: "42.84%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 3,
  },
  tableCellHeader: {
    margin: 5,
    fontSize: 11, // Increased from 10 to match web preview
    fontWeight: "bold",
  },
  tableCell: {
    margin: 5,
    fontSize: 10, // Increased from 9 to improve readability
  },
  tableCellRight: {
    margin: 5,
    fontSize: 10, // Increased from 9
    fontWeight: "medium",
    textAlign: "right",
  },
  valueCentered: {
    margin: 5,
    fontSize: 12, // Increased from 10 for emphasis
    fontWeight: "bold",
    textAlign: "center",
  },
  tableCellHeaderSmall: {
    margin: 1,
    fontSize: 7, // Slightly increased from 6 for better readability
    fontWeight: "bold",
    textAlign: "center",
  },
  colSpan7: {
    flex: 7,
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  colSpan2: {
    width: "33%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center",
    padding: 3,
  },
  colSpan3: {
    width: "48%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center",
    padding: 3,
  },
  image: {
    width: 20,
    height: 20,
    marginBottom: 2,
    objectFit: "contain",
  },
  flexContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 5,
  },
  flexContainerVertical: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 3,
    padding: 2,
  },
  total: {
    fontWeight: "bold",
  },
  percentage: {
    fontWeight: "bold",
    textAlign: "right",
  },
  value: {
    fontWeight: "bold",
    textAlign: "right",
  },
  bold: {
    fontWeight: "bold",
  },
  evaluationContainer: {
    marginTop: 30, // Add space between tables
  },
  reasonIcon: {
    width: 16,
    height: 16,
    marginBottom: 2,
    objectFit: "contain",
  },
});
